module.exports = __webpack_public_path__ + "img/correios-logo.f5130da7.svg";